/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/pager-duty" */ '@atlassian/logo-third-party/pager-duty'
		).then((m) => m.PagerDutyIcon),
	{ moduleId: '@atlassian/logo-third-party/pager-duty' },
);

const LazyPagerDutyIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-pagerduty" */ './utils').then((m) => m.PagerDutyIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon' },
);

const LazyPagerDutySearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-pagerduty-search-result" */ './utils').then(
			(m) => m.PagerDutySearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const PagerDutyIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyPagerDutyIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const PagerDutySearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyPagerDutySearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
